export const isSSR = typeof window === 'undefined';
export const isProduction = process.env.NODE_ENV === 'production';

export const isSafari = !isSSR
    ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    : false;

export const localStorageExists = typeof localStorage !== 'undefined';
